import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ExtraSalesSummaryReportData} from "./extra-sales-summary-report.data";

@Injectable()
export class ExtraSalesSummaryReportModel extends ReportModel<ExtraSalesSummaryReportData> {
    constructor(injector: Injector) {
        super(injector, ExtraSalesSummaryReportData);
    }
}
